export const StudentActions = {
  TOGGLE_LOADER: '@StudentActions/TOGGLE_LOADER',
  TOGGLE_ERROR: '@StudentActions/TOGGLE_ERROR',
  UPDATE_DATA: '@StudentActions/UPDATE_DATA',
};

const studentState = {
  isLoading: false,
  isError: false,
  studentData: {},
};

const StudentReducer = (state = studentState, action) => {
  switch (action.type) {
    case StudentActions.TOGGLE_LOADER:
      return { ...state, isLoading: !state.isLoading };
    case StudentActions.TOGGLE_ERROR:
      return { ...state, isError: !state.isError };
    case StudentActions.UPDATE_DATA:
      return { ...state, [action.dataType]: action.dataValue };
    default:
      return { ...state };
  }
};

export default StudentReducer;
